import { useModal } from "contexts/modalContext/modalContext";
import RemoveExpiredMailModal from "./RemoveExpiredMailModal";
import { MailDataI } from "models/models";

const useRemoveExpiredMailAction = () => {
  const { setModal } = useModal();

  return (mailData: MailDataI, cb: () => void) => ({
    name: "remove-mail-completely",
    iconName: "remove",
    clickAction: () => {
      setModal({
        modal: RemoveExpiredMailModal,
        props: {
          encryptedMailIds: [mailData.id],
          cb,
        },
      });
    },
  });
};

export default useRemoveExpiredMailAction;
